var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EmbedCard',{attrs:{"params":_vm.$route.query,"buyable":_vm.training},on:{"load":_vm.postDimensions}})}
var staticRenderFns = []

export { render, staticRenderFns }